var AWSAPIServiceModule = /** @class */ (function () {
    function AWSAPIServiceModule() {
    }
    return AWSAPIServiceModule;
}());
export { AWSAPIServiceModule };
